export enum IncontextDisplayModes {
  IFRAME = 'IFRAME',
  POPUP = 'POPUP',
}

export enum PreferredDisplayMode {
  IN_CONTEXT = 'IN_CONTEXT',
  REDIRECT = 'REDIRECT',
}
